import { Injectable } from '@angular/core';
import { MonthlyCutBase } from "./monthly-cut-base";
import {
    MonthlyCut as T
} from '../Interfaces';
export class MonthlyCut extends MonthlyCutBase implements T {
    id: number;
    month: number;
    year: number;
    income: number;
    expense: number;
    net_income: number;
    property_count: number;
    investor_count: number;
    authorization: any;
    constructor(json) {
        super(json);
    }
    unAuthorized(user) {
        return this.hierarchyLogic(user);
    }
    private hierarchyLogic(user) {
        // 4: admin, 3:manager, 2:ceo, 1: owner
        if (!this.authorization) return false;
        return (this.authorization.state == 'need_auth' && this.hasRole(user, [3, 4])) ||
            (this.authorization.state == 'auth_2' && this.hasRole(user, [2])) ||
            (this.authorization.state == 'auth_1' && this.hasRole(user, [1]));
    }

    toString(): string {
        return `Corte ${this.monthName} ${this.year}`;
    }

    hasRole(user, rolesIds) {
        let result = false;
        user.role.forEach(role => {
            if (rolesIds.includes(role.id)) {
                result = true;
            } else {
                result = false;
            }
        });
        return result;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/monthly-cut.ts